const cityList = [
  // {
  //   name: '标准版',
  //   imgUrl: require('@assets/img/investments/city1.jpg'),
  //   url: 'http://tzjc.cric.com'
  // },
  {
    name: '环京',
    imgUrl: require('@assets/img/investments/city2.jpg'),
    url: 'https://svip.cric.com/productions'
  },
  {
    name: '大湾区',
    imgUrl: require('@assets/img/investments/city3.jpg'),
    url: 'https://svip.cric.com/productions'
  },
  {
    name: '广西',
    imgUrl: require('@assets/img/investments/city5.jpg'),
    url: 'https://svip.cric.com/productions'
  },
  {
    name: '浙江',
    imgUrl: require('@assets/img/investments/city14.jpg'),
    url: 'https://svip.cric.com/productions'
  },
  {
    name: '云南',
    imgUrl: require('@assets/img/investments/city16.jpg'),
    url: 'https://svip.cric.com/productions'
  },
  // {
  //   name: '山东',
  //   imgUrl: require('@assets/img/investments/city11.jpg'),
  //   url: 'https://svip.cric.com/productions'
  // },
  {
    name: '福建',
    imgUrl: require('@assets/img/investments/city4.jpg'),
    url: 'https://svip.cric.com/productions'
  },
  // {
  //   name: '河南',
  //   imgUrl: require('@assets/img/investments/city6.jpg'),
  //   url: 'https://svip.cric.com/productions'
  // },
  // {
  //   name: '安徽',
  //   imgUrl: require('@assets/img/investments/city9.jpg'),
  //   url: 'https://svip.cric.com/productions'
  // },
  {
    name: '苏北',
    imgUrl: require('@assets/img/investments/city13.jpg'),
    url: 'https://svip.cric.com/productions'
  },
  // {
  //   name: '环南京',
  //   imgUrl: require('@assets/img/investments/city10.jpg'),
  //   url: 'https://svip.cric.com/productions'
  // },
  // {
  //   name: '湖南',
  //   imgUrl: require('@assets/img/investments/city8.jpg'),
  //   url: 'https://svip.cric.com/productions'
  // },
  {
    name: '苏州',
    imgUrl: require('@assets/img/investments/city15.jpeg'),
    url: 'https://svip.cric.com/productions'
  },
  // {
  //   name: '陕西',
  //   imgUrl: require('@assets/img/investments/city17.jpg'),
  //   url: 'https://svip.cric.com/productions'
  // },
  {
    name: '四川',
    imgUrl: require('@assets/img/investments/city12.jpg'),
    url: 'https://svip.cric.com/productions'
  },
  // {
  //   name: '湖北',
  //   imgUrl: require('@assets/img/investments/city7.jpg'),
  //   url: 'https://svip.cric.com/productions'
  // },
]

export {
  cityList
}